"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustWeightModalProvider = AdjustWeightModalProvider;
exports.useAdjustWeightModalStore = useAdjustWeightModalStore;
const react_1 = __importStar(require("react"));
const immer_1 = require("immer");
const zustand_1 = require("zustand");
const helper_1 = require("./helper");
const createModalStore = (initProps) => {
    return (0, zustand_1.createStore)()((set, get) => {
        const defaultProps = {
            isIndividual: false,
            level: 0,
            isCreate: false,
            fromBadgeWeight: false,
            maxSumOfObjectivesOnBasedOnCategory: false,
            maxSumOfObjectivesBasedOnCategory: 0,
            isPercentage: false,
            isSubGoal: false,
            objectives: [],
            isParent: !!(initProps?.level === 0 || !initProps?.isIndividual),
            isComplexity: !!(initProps?.isIndividual && initProps?.objectives?.[0]?.type == 'task')
        };
        const objectivesData = initProps?.isIndividual
            ? (0, helper_1.restructureObjectivesData)(initProps.objectives, initProps.fromBadgeWeight)
            : [];
        const defaultState = {
            objectivesData: objectivesData,
            editedObjectivesData: objectivesData,
            totalWeights: 0,
            totalObjectives: 0,
            objectiveCategories: [],
            payloadBody: {
                objectives: []
            }
        };
        return {
            ...defaultProps,
            ...defaultState,
            ...initProps,
            setObjectivesData: (data) => {
                return set({ objectivesData: data });
            },
            setEditedObjectivesData: (data) => {
                return set({ editedObjectivesData: data });
            },
            setTotalWeights: (data) => set({ totalWeights: data }),
            setTotalObjectives: (data) => set({ totalObjectives: data }),
            setObjectiveCategories: (data) => {
                return set({ objectiveCategories: data });
            },
            handleToggleWeight: (objectiveId) => {
                return (0, helper_1.handleToggleWeight)(objectiveId, get, set);
            },
            handleChangeWeightInput: (objectiveId, inputWeightValue) => {
                return (0, helper_1.handleChangeWeightInput)(objectiveId, inputWeightValue, get, set);
            },
            handleChangeWeightError: (objectiveId, errorValue) => {
                return (0, helper_1.handleChangeWeightError)(objectiveId, errorValue, get, set);
            },
            handleChangeCategory: (objectiveId, objectiveCategory) => {
                return (0, helper_1.handleChangeCategory)(objectiveId, objectiveCategory, get, set);
            },
            handleChangeComment: (inputValue) => {
                return set((0, immer_1.produce)((state) => {
                    state.payloadBody.comment = inputValue;
                }));
            },
            handleAdjustWeight: (objectiveId, inputWeightValue) => {
                const { handleChangeWeightInput } = get();
                return handleChangeWeightInput(objectiveId, inputWeightValue);
            },
            handleChangeComplexity: (objectiveId, complexityId) => {
                return (0, helper_1.handleChangeComplexity)(objectiveId, complexityId, get, set);
            }
        };
    });
};
const ModalContext = (0, react_1.createContext)(null);
function AdjustWeightModalProvider({ children, ...props }) {
    const storeRef = (0, react_1.useRef)();
    if (!storeRef.current) {
        storeRef.current = createModalStore(props);
    }
    return (react_1.default.createElement(ModalContext.Provider, { value: storeRef.current }, children));
}
function useAdjustWeightModalStore(selector, equalityFn) {
    const store = (0, react_1.useContext)(ModalContext);
    if (!store)
        throw new Error('Missing ModalContext.Provider in the tree');
    return (0, zustand_1.useStore)(store, selector, equalityFn);
}
